import React, { useEffect, useState } from 'react'
import { basicCaseInfo } from '../CaseFormFields'
import { getCasesApi } from 'Constants'
import { getCaseType, getNetWorth } from 'Utils'

function RequiredInfo({
    caseDetails,
    clientPage = false,
}) {
    const [basicArray, setBasicArray] = useState([]);
    useEffect(() => {
        if(clientPage) {
            setBasicArray ([ 
                {
                    "label" : "Name",
                    "name" : "firstName"
                },
                {
                    "label" : "Is client annonymous",
                    "name" : "isOwnerAnonymous"
                },
                
                ...basicCaseInfo[0],
                
                {
                    "label" : "Is this an SOS case?",
                    "name" : "sos"  
                },
                {
                    "label" : "Is this a class action lawsuit?",
                    "name" : "isClassAction"
                },
                {
                    "label" : "Is this against an entity or an individual?",
                    "name" : "isEntity"
                },
                {
                    "label" : "Do you know any other plaintiffs with the same case against this person or entity, or is it just you?",
                    "name" : "defendant"
                },
                {
                    "label" : "Is the adverse party a public company?",
                    "name" : "adversePartyPublicCompany"

                },
                {
                    "label" : "Are you the plaintiff in this case or are you a family member/friend/advisor seeking an attorney on that person's behalf?",
                    "name" : "isPostedBySelf"
                },
                {
                    "label" : "What is the net worth of the adverse party?",
                    "name" : "adversePartyNetWorth"
                },
                {
                    "label" : "Is the adverse party a public company?",
                    "name" : "adversePartyPublicCompany"
                },
                {
                    "label" : "Are you currently represented by an attorney?",
                    "name" : "attAvailable"
                },
                {
                    "label" : "Proof available",
                    "name" : "proofList"
                }
            ]);
        }
        else
        {
            setBasicArray([ 
                {
                    "label" : "Name",
                    "name" : "firstName"
                },
                {
                    "label" : "Last Name",
                    "name" : "lastName"
                },
                {
                    "label" : "Is client annonymous",
                    "name" : "isOwnerAnonymous"
                },
                
                ...basicCaseInfo[0],
                
               
            ]);

        }
    }, [clientPage])

  
  return (
    
        basicArray?.map((item) => {
            if(caseDetails?.[item.name]) 
            {
                return (
                    <div className='flex mb-4 grid grid-cols-4 lg:grid-cols-3  gap-2'>
                        <div className=' text-gray-600  col-span-2'>{item.label} </div>
                        <div className={ "col-span-2 lg:col-span-1 w-full truncate " + 
                            (item.name !== "contactEmail" &&
                            'capitalize')}>{
                            item.name === "contactEmail" ? 
                            <a className="underline" href={"mailto:"+caseDetails?.[item.name]}>{caseDetails?.[item.name]}</a>
                           :
                            item.name === "contactPhone" ? 
                            <a className="underline" 
                            href={"tel:"+caseDetails?.[item.name]}>{caseDetails?.[item.name]}</a>
                            :
                        item.name === "dateInfo" ? 
                        new Date(caseDetails?.[item.name]).toDateString() 
                        : 
                        (typeof caseDetails?.[item.name] === "boolean" ?
                            (caseDetails?.[item.name] === true ? "yes" : "no")
                            :
                            item.name === "firstName" ? 
                                caseDetails?.[item.name] !== "null" ? caseDetails?.[item.name] + " " + caseDetails?.lastName : "Not provided"
                            :
                            (item.name === "caseType" ? 
                               getCaseType(caseDetails?.[item.name])
                            :
                            item.name === "isEntity" ?
                            (caseDetails?.[item.name] === "yes" ? "Entity" : "Individual")
                            :
                            item.name === "defendant" ?
                            (caseDetails?.[item.name] === "yes" ? "Other similar people too" : "Just me")
                            :
                            item.name === "adversePartyNetWorth" ?
                            getNetWorth(caseDetails?.[item.name])
                            :
                            item.name === "adversePartyPublicCompany" ?
                            (caseDetails?.[item.name] === "yes" ? "Yes" : (
                                caseDetails?.[item.name] === "no" ? "No" : "Unknown"
                            ))
                            :
                        caseDetails?.[item.name]))}</div>
                    </div>
                    )
                    
             }
        })
    
  )
} 

export default RequiredInfo